import React from "react";
import {
  ListItem,
  makeStyles,
  createStyles,
  Theme,
  ListItemAvatar,
  Avatar,
} from "@material-ui/core";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    listItem: {
      justifyContent: "center",
    },
    listItemAvatar: {
      minWidth: "28px",
    },
    avater: {
      width: "28px",
      height: "28px",
    },
  })
);

interface Props {
  avatarChar: string;
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
}

/** サイドバーナビゲータアイテムアバター */
export function SidebarNavItemAvatar(props: Props) {
  const classes = useStyles();

  const { avatarChar, handleClick } = props;

  //--------------------
  // コンポーネント
  return (
    <ListItem button className={classes.listItem} onClick={handleClick}>
      <ListItemAvatar className={classes.listItemAvatar}>
        <Avatar className={classes.avater}>{avatarChar}</Avatar>
      </ListItemAvatar>
    </ListItem>
  );
}
